import React from 'react';
import ActivityMediumBox from '../Box/ActivityMediumBox';
import Buttonbar from '../Navbar/Buttonbar';
import ViewSubTypeForYearRadioBar from '../Navbar/ViewSubTypeForYearRadioBar';
import ChipActivity from '../../../../components/Chip/ChipActivity';
import ChipCheckedActivity from '../../../../components/Chip/ChipCheckedActivity';
import StackedBarChart from '../Chart/StackedBarChart';
import NoDataBox from '../Box/NoDataBox';
import { getHoverText, dayDate, yearDate, countDays } from '../../../../utils/summaryGraph';
import * as ActionColors from '../../../../themes/summaryReportColor';

import * as moment from 'moment';

const getLable = (lable, t) => {
  let result = '';
  switch (lable) {
    case 'walking':
      result = `${t('walking')}`;
      break;
    case 'standing':
      result = `${t('standing')}`;
      break;
    case 'sitting':
      result = `${t('sitting')}`;
      break;
    case 'lying':
      result = `${t('lying')}`;
      break;
    case 'lyingOnRight':
      result = `${t('on_right')}`;
      break;
    case 'lyingOnLeft':
      result = `${t('on_left')}`;
      break;
    case 'lyingOnBack':
      result = `${t('on_back')}`;
      break;
    case 'lyingOnStomach':
      result = `${t('on_stomach')}`;
      break;
    case 'lyingTotal':
      result = `${t('total')}`;
      break;
    default:
      break;
  }
  return result;
};

const TotalSleepLegend = (props) =>
  props.data.map((val, i) => {
    return (
      <div className='flex w-full my-auto' key={i}>
        <div className='block w-3/4'>
          <ChipActivity lable={getLable(val.label, props.t)} element={val.label} />
        </div>
        <div className='block w-3/12'>
          <div className='text-xl font-medium text-right text-summary-header '>
            {val.value.toFixed(2)}
            <span className='px-2 text-base font-normal capitalize text-summary-header '>
              %{/* {props.t("hrs")}. */}
            </span>
          </div>
        </div>
      </div>
    );
  });

const AverageSleepLegend = (props) =>
  props.data.map((val, i) => {
    return (
      <div className='flex w-full my-auto' key={i}>
        <div className='block w-3/4'>
          <ChipActivity lable={getLable(val.label, props.t)} element={val.label} />
        </div>
        <div className='block w-3/12'>
          <div className='mr-2 text-xl font-medium text-right text-summary-header '>{val.value}</div>
        </div>
      </div>
    );
  });

const Sleep = (props) => {
  const { t } = props;
  const margin = {
    top: 20, //20,
    right: 20, //20,
    bottom: 40, //40,
    left: 60, //60
  };
  const width = 740 - margin.left - margin.right;
  const height = 515 - margin.top - margin.bottom;

  const sleepColor = {
    lyingTotal: ActionColors.COLOR_TOTAL,
    lyingOnLeft: ActionColors.COLOR_LYING_ON_LEFT_SIDE,
    lyingOnRight: ActionColors.COLOR_LYING_ON_RIGHT_SIDE,
    lyingOnStomach: ActionColors.COLOR_LYING_ON_STOMACH,
    lyingOnBack: ActionColors.COLOR_LYING_ON_BACK,
  };

  const display = {
    lyingTotal: props.display.lyingTotal,
    lyingOnLeft: props.display.lyingOnLeft,
    lyingOnRight: props.display.lyingOnRight,
    lyingOnStomach: props.display.lyingOnStomach,
    lyingOnBack: props.display.lyingOnBack,
  };
  const lableX = props.viewType === 'year' ? t('months') : t('days_for_graph');

  const viewSubTypeForYear = props.viewSubTypeForYear;
  const viewYearTypeRadioBar =
    props.viewType === 'year' ? (
      <ViewSubTypeForYearRadioBar
        viewType={props.viewType}
        viewSubType={viewSubTypeForYear}
        t={t}
        onChangeSubViewType={(subType) => {
          props.onChangeViewSubTypeForYear('sleep', subType);
        }}
      />
    ) : (
      <></>
    );

  return props.hasActivity ? (
    <div className='flex-wrap flex-auto min-w-0 px-16 mb-16'>
      <div className='relative flex-col flex-wrap block col-span-12 mx-3 my-4 bg-white rounded shadow-lg'>
        <div className='block col-span-12 px-1 pt-4 lg:flex md:flex'>
          <Buttonbar onChangePeriod={props.onChangePeriod} viewType={props.viewType} t={t} />
          <div className='flex flex-auto justify-end pr-8'>{viewYearTypeRadioBar}</div>
        </div>

        <div className='px-6 pb-5'>
          <div className='flex-wrap block xl:flex'>
            <div className='w-full p-4 pt-1 xl:w-2/3'>
              <div className='flex flex-wrap flex-grow col-span-12 my-1'>
                <ChipCheckedActivity data={sleepLegend(props.data, props.display)} onSelect={props.onSelect} t={t} />
              </div>
              <div className='rounded-md xl:mb-5 lg:mb-5 bg-primary-gradient h-428'>
                <StackedBarChart
                  width={width}
                  height={height}
                  margin={margin}
                  color={sleepColor}
                  rect={rectProperty(props.viewType, viewSubTypeForYear)}
                  data={sleepGraphData(props.date, props.data, props.viewType, viewSubTypeForYear, props.display, t)}
                  onMouseover={props.onMouseover}
                  onMouseout={props.onMouseout}
                  tooltip={props.tooltip}
                  tooltipName={getLable(props.tooltip.name, t)}
                  unit={t('hours')}
                  lableX={lableX}
                />
              </div>
            </div>

            <div className='w-full xl:w-1/3 lg:mt-16 xl:mt-0 md:-mt-8'>
              <div className='lg:flex xl:block'>
                <div className='mx-4 my-2 xl:mx-4 lg:mx-2 md:mx-4'>
                  <ActivityMediumBox header={`${t('total')} / ${t(props.viewType)}`}>
                    <div className='mt-2'>
                      <TotalSleepLegend data={sleepTotal(props.data, display)} t={t} />
                    </div>
                  </ActivityMediumBox>
                </div>

                <div className='mx-4 my-2 xl:mx-4 lg:mx-2 md:mx-4'>
                  <ActivityMediumBox header={`${t('avg')} / ${t('day')} (${t('hour')})`}>
                    <div className='mt-2'>
                      <AverageSleepLegend data={sleepAverage(props.date, props.data, props.viewType, display)} t={t} />
                    </div>
                  </ActivityMediumBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className='flex-wrap flex-auto min-w-0 px-16'>
      <NoDataBox text={t('no_data')} />
    </div>
  );
};

const rectProperty = (viewType, viewSubTypeForYear) => {
  const rectWeek = { width: 30, padding: 0.7, maxValue: 24 };
  const rectMonth = { width: 15, padding: 0.5, maxValue: 24 };
  const rectYear = { width: 30, padding: 0.45, maxValue: 800 };
  const rectYearAverage = { width: 30, padding: 0.45, maxValue: 24 };

  if (viewType === 'week') {
    return rectWeek;
  } else if (viewType === 'month') {
    return rectMonth;
  }

  if (viewSubTypeForYear === 'average') {
    //for displaying the average per day (from the year graph)
    return rectYearAverage;
  }
  return rectYear;
};

const sleepLegend = (data, display) => {
  let total = {
    lyingTotal: 0,
    lyingOnBack: 0,
    lyingOnStomach: 0,
    lyingOnLeft: 0,
    lyingOnRight: 0,
  };

  if (data && data.length > 0) {
    total = (data || [])
      .map((d) => {
        return {
          lyingOnBack: d.duration.lyingOnBack,
          lyingOnStomach: d.duration.lyingOnStomach,
          lyingOnLeft: d.duration.lyingOnLeft,
          lyingOnRight: d.duration.lyingOnRight,
        };
      })
      .reduce(
        (a, b) => ({
          lyingOnBack: a.lyingOnBack + b.lyingOnBack,
          lyingOnStomach: a.lyingOnStomach + b.lyingOnStomach,
          lyingOnLeft: a.lyingOnLeft + b.lyingOnLeft,
          lyingOnRight: a.lyingOnRight + b.lyingOnRight,
        }),
        total,
      );
  }

  //convert seconds to hours
  total.lyingOnBack = total.lyingOnBack / 3600;
  total.lyingOnStomach = total.lyingOnStomach / 3600;
  total.lyingOnLeft = total.lyingOnLeft / 3600;
  total.lyingOnRight = total.lyingOnRight / 3600;

  const result = [
    {
      label: 'lyingTotal',
      checked: display.lyingTotal,
    },
    {
      label: 'lyingOnBack',
      checked: display.lyingOnBack,
      show: +total.lyingOnBack.toFixed(2) > 0,
    },
    {
      label: 'lyingOnStomach',
      checked: display.lyingOnStomach,
      show: +total.lyingOnStomach.toFixed(2) > 0,
    },
    {
      label: 'lyingOnLeft',
      checked: display.lyingOnLeft,
      show: +total.lyingOnLeft.toFixed(2) > 0,
    },
    {
      label: 'lyingOnRight',
      checked: display.lyingOnRight,
      show: +total.lyingOnRight.toFixed(2) > 0,
    },
  ];
  return result;
};

const sleepTotal = (data, display) => {
  let total = {
    lyingOnBack: 0,
    lyingOnStomach: 0,
    lyingOnLeft: 0,
    lyingOnRight: 0,
  };

  if (data && data.length > 0) {
    total = (data || [])
      .map((d) => {
        return {
          lyingOnBack: d.duration.lyingOnBack,
          lyingOnStomach: d.duration.lyingOnStomach,
          lyingOnLeft: d.duration.lyingOnLeft,
          lyingOnRight: d.duration.lyingOnRight,
        };
      })
      .reduce(
        (a, b) => ({
          lyingOnBack: a.lyingOnBack + b.lyingOnBack,
          lyingOnStomach: a.lyingOnStomach + b.lyingOnStomach,
          lyingOnLeft: a.lyingOnLeft + b.lyingOnLeft,
          lyingOnRight: a.lyingOnRight + b.lyingOnRight,
        }),
        total,
      );
  }

  //convert seconds to hours
  total.lyingOnBack = total.lyingOnBack / 3600;
  total.lyingOnStomach = total.lyingOnStomach / 3600;
  total.lyingOnLeft = total.lyingOnLeft / 3600;
  total.lyingOnRight = total.lyingOnRight / 3600;

  const totalTime = Object.values(total).reduce((a, b) => a + b, 0);

  const lyingOnBack = total.lyingOnBack ? (total.lyingOnBack / totalTime) * 100 : 0;
  const lyingOnStomach = total.lyingOnStomach ? (total.lyingOnStomach / totalTime) * 100 : 0;
  const lyingOnLeft = total.lyingOnLeft ? (total.lyingOnLeft / totalTime) * 100 : 0;
  const lyingOnRight = total.lyingOnRight ? (total.lyingOnRight / totalTime) * 100 : 0;

  const result = [
    {
      label: 'lyingOnBack',
      value: lyingOnBack,
    },
    {
      label: 'lyingOnStomach',
      value: lyingOnStomach,
    },
    {
      label: 'lyingOnLeft',
      value: lyingOnLeft,
    },
    {
      label: 'lyingOnRight',
      value: lyingOnRight,
    },
  ];
  return result;
};

const sleepAverage = (date, data, viewType, display) => {
  const totalDays = countDays(viewType, data);

  let totalAverage = {
    lyingOnBack: 0,
    lyingOnStomach: 0,
    lyingOnLeft: 0,
    lyingOnRight: 0,
  };

  const sleepData = (data || []).map((d) => {
    return {
      lyingOnBack: d.duration.lyingOnBack ? d.duration.lyingOnBack : 0,
      lyingOnStomach: d.duration.lyingOnStomach ? d.duration.lyingOnStomach : 0,
      lyingOnLeft: d.duration.lyingOnLeft ? d.duration.lyingOnLeft : 0,
      lyingOnRight: d.duration.lyingOnRight ? d.duration.lyingOnRight : 0,
    };
  });

  if (sleepData && sleepData.length > 0) {
    // summary all
    totalAverage = sleepData.reduce(
      (a, b) => ({
        lyingOnBack: a.lyingOnBack + b.lyingOnBack,
        lyingOnStomach: a.lyingOnStomach + b.lyingOnStomach,
        lyingOnLeft: a.lyingOnLeft + b.lyingOnLeft,
        lyingOnRight: a.lyingOnRight + b.lyingOnRight,
      }),
      totalAverage,
    );
  }

  // find average in hours
  // const totalSeconds = totalDays * 3600;
  const result = [
    {
      label: 'lyingOnBack',
      value: formattedNumber(totalAverage.lyingOnBack / totalDays),
      min: formattedNumber(
        Math.min.apply(
          null,
          sleepData.map((item) => item.lyingOnBack),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          sleepData.map((item) => item.lyingOnBack),
        ) / totalDays,
      ),
    },
    {
      label: 'lyingOnStomach',
      value: formattedNumber(totalAverage.lyingOnStomach / totalDays),
      min: formattedNumber(
        Math.min.apply(
          null,
          sleepData.map((item) => item.lyingOnStomach),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          sleepData.map((item) => item.lyingOnStomach),
        ) / totalDays,
      ),
    },
    {
      label: 'lyingOnLeft',
      value: formattedNumber(totalAverage.lyingOnLeft / totalDays),
      min: formattedNumber(
        Math.min.apply(
          null,
          sleepData.map((item) => item.lyingOnLeft),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          sleepData.map((item) => item.lyingOnLeft),
        ) / totalDays,
      ),
    },
    {
      label: 'lyingOnRight',
      value: formattedNumber(totalAverage.lyingOnRight / totalDays),
      min: formattedNumber(
        Math.min.apply(
          null,
          sleepData.map((item) => item.lyingOnRight),
        ) / totalDays,
      ),
      max: formattedNumber(
        Math.max.apply(
          null,
          sleepData.map((item) => item.lyingOnRight),
        ) / totalDays,
      ),
    },
  ];

  return result;
};

const formattedNumber = (num) => {
  let isFinite = Number.isFinite(num);
  if (isFinite) {
    let minutes = Math.round(num / 60);
    minutes = minutes % 60;
    let hours = Math.floor(num / 3600);
    let minutesFormat = `${minutes === 0 ? '00' : minutes < 10 ? '0' + minutes : minutes}`;
    let hoursFormat = `${hours === 0 ? '00' : hours < 10 ? '0' + hours : hours}`;
    return `${hoursFormat}:${minutesFormat}` === '00:00' ? 0 : `${hoursFormat}:${minutesFormat}`;
  } else {
    return '0';
  }
};

const getLyingValueTotal = (isCalucateAverageForYear, duration, divider, noOfDate) => {
  const sum =
    +(duration.lyingOnBack / divider).toFixed(2) +
    +(duration.lyingOnStomach / divider).toFixed(2) +
    +(duration.lyingOnLeft / divider).toFixed(2) +
    +(duration.lyingOnRight / divider).toFixed(2);

  if (isCalucateAverageForYear) {
    return (sum / noOfDate).toFixed(2);
  }
  return sum;
};

const getLyingValue = (isCalucateAverageForYear, value, divider, noOfDate) => {
  if (isCalucateAverageForYear) {
    return (value / (noOfDate * divider)).toFixed(2);
  }
  return (value / divider).toFixed(2);
};

const sleepGraphData = (date, data, viewType, viewSubTypeForYear, display, t) => {
  const templateSleepDate = {
    lyingTotal: { value: 0, hoverTxt: '', nameTxt: '' },
    lyingOnBack: { value: 0, hoverTxt: '', nameTxt: '' },
    lyingOnStomach: { value: 0, hoverTxt: '', nameTxt: '' },
    lyingOnLeft: { value: 0, hoverTxt: '', nameTxt: '' },
    lyingOnRight: { value: 0, hoverTxt: '', nameTxt: '' },
  };
  let templateData = [];
  let isCalucateAverageForYear = false; //isCalucateAverage : calculate average or summary
  if (viewType === 'week') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateSleepDate };
    });
  } else if (viewType === 'month') {
    const dateStart = moment(new Date(`${date}`))
      .subtract(4, 'w')
      .add(1, 'd')
      .startOf('day')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .endOf('day')
      .toDate();

    const dateRange = dayDate(dateStart, dateEnd, viewType);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateSleepDate };
    });
  } else {
    const dateStart = moment(new Date(`${date}`))
      .subtract(1, 'y')
      .add(1, 'd')
      .startOf('month')
      .toDate();
    const dateEnd = moment(new Date(`${date}`))
      .startOf('month')
      .toDate();

    if (viewSubTypeForYear === 'average') {
      isCalucateAverageForYear = true;
    }

    const dateRange = yearDate(dateStart, dateEnd);
    templateData = (dateRange || []).map((d) => {
      return { ...d, ...templateSleepDate };
    });
  }

  (data || []).forEach((d) => {
    if (d.duration) {
      const refDate = moment(new Date(`${d.createdDate}`));
      const found = templateData.find((t) => {
        if (viewType === 'year') {
          // return moment(t.refDate).isSame(refDate, 'month');
          return t.refDate === d.month;
        }
        return moment(t.refDate).isSame(refDate, 'day');
      });
      if (found) {
        found.lyingTotal = display.lyingTotal
          ? {
              value: +getLyingValueTotal(isCalucateAverageForYear, d.duration, 3600, d.noOfDate),
              hoverTxt: getHoverText(getLyingValueTotal(isCalucateAverageForYear, d.duration, 1, d.noOfDate)),
              nameTxt: `${t('total')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };

        found.lyingOnBack = display.lyingOnBack
          ? {
              value: +getLyingValue(isCalucateAverageForYear, d.duration.lyingOnBack, 3600, d.noOfDate),
              hoverTxt: getHoverText(getLyingValue(isCalucateAverageForYear, d.duration.lyingOnBack, 1, d.noOfDate)),
              nameTxt: `${t('on_back')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.lyingOnStomach = display.lyingOnStomach
          ? {
              value: +getLyingValue(isCalucateAverageForYear, d.duration.lyingOnStomach, 3600, d.noOfDate),
              hoverTxt: getHoverText(getLyingValue(isCalucateAverageForYear, d.duration.lyingOnStomach, 1, d.noOfDate)),
              nameTxt: `${t('on_stomach')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.lyingOnLeft = display.lyingOnLeft
          ? {
              value: +getLyingValue(isCalucateAverageForYear, d.duration.lyingOnLeft, 3600, d.noOfDate),
              hoverTxt: getHoverText(getLyingValue(isCalucateAverageForYear, d.duration.lyingOnLeft, 1, d.noOfDate)),
              nameTxt: `${t('on_left')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
        found.lyingOnRight = display.lyingOnRight
          ? {
              value: +getLyingValue(isCalucateAverageForYear, d.duration.lyingOnRight, 3600, d.noOfDate),
              hoverTxt: getHoverText(getLyingValue(isCalucateAverageForYear, d.duration.lyingOnRight, 1, d.noOfDate)),
              nameTxt: `${t('on_right')}`,
            }
          : { value: 0, hoverTxt: '', nameTxt: '' };
      }
    }
  });

  return templateData;
};

export default Sleep;
